var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page25"},[_c('video',{ref:"Video",attrs:{"src":"/videos/team.MP4","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }